const limitPagination = () => {
  $('.limit_pagination').on('change', function () {
    $(this).closest('form').submit();
  });
};
export default limitPagination;



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/app/assets/javascripts/packs/common/pagination.js